<template>
   <el-tabs type="border-card" style="height:auto">
    <el-tab-pane label="PC大类列表" style="height:auto" >
      <el-table
        :data="data" border style="width: 100%">
        <el-table-column
          fixed
          prop="id"
          label="ID编号" width="100">
        </el-table-column>
        <el-table-column
          prop="name"
          label="大类名称" >
        </el-table-column>
        <el-table-column
          prop="icon"
          label="icon显示">
        </el-table-column>
        <el-table-column
          prop="sort"
          label="排序">
        </el-table-column>
        <el-table-column
          prop="createDate"
          label="操作时间">
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          width="160">
          <template slot-scope="scope">
            <el-button
              size="mini"
              @click="handleEdit(scope.row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-tab-pane>
   </el-tabs>
</template>
<script>

export default {
  data() {
    return {
      data: [],
      optionItem: {
        token: this.user.getToken()
      },
      firstCategory: {
        token: this.user.getToken()
      }
    };
  },
  methods: {
    handleEdit: function(row) {
      this.$router.push({name:'firstCategoryEditor',params:row})
    },
    getFirstCategoryData: function() {
      // 初始化默认加载菜单
      this.http.post(
        '/firstCategory/list',
        this.optionItem,
        res => {
          if (res.success) {
            // 返回正确的处理
            this.data = res.datas.data;
          } else {
            // 返回错误的处理
            this.$message.error(res.message)
          }
        }
      );
    }
  },
  mounted: function() {
    this.getFirstCategoryData();
  }
};
</script>


<style>
.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}

.el-input--suffix .el-input__inner {
  padding-right: 16px;
}
</style>


// WEBPACK FOOTER //
// src/components/views/category/firstCategory.vue